export const NATURE_ALLOWED_TYPES: Record<string, string[]> = {
  routine: ["Mill", "Vehicle"],
  stock: ["Mill"],
  capital: ["Mill"],
  payroll: ["Mill", "Vehicle"], // Payroll can be for both Mill operations and Vehicle maintenance staff
  recurring: ["Mill"],
  "admin-finance": ["Mill"],
  maintenance: ["Mill", "Vehicle"], // Maintenance can be for both Mill equipment and Vehicles
};
